import { ErrorResponse, isErrorResponse } from "@types"
import customFetch from "./helper"
import { toast } from "sonner"
import { ProcessedEntry } from "@/types/import"
import { FeedData as Feed } from "@extractus/feed-extractor"

const API = "/import"

export async function getPostByUrl(
  url: string
): Promise<ProcessedEntry | null> {
  const response = await customFetch<ProcessedEntry | ErrorResponse>(
    `${API}/post?url=${url}`
  )

  if (isErrorResponse(response)) {
    toast.error(response.msg)
    return null
  }

  return response
}

export async function getFeedFromURL(url: string): Promise<Feed | null> {
  try {
    const response = await customFetch<{ feed: Feed } | ErrorResponse>(
      `${API}/feed?url=${encodeURIComponent(url)}`
    )

    if (isErrorResponse(response)) {
      toast.error(response.msg)
      return null
    }

    return response.feed
  } catch (error) {
    console.error("Error getting feed:", error)
    return null
  }
}

export async function isOnMirror(walletAddress: string): Promise<boolean> {
  try {
    const response = await customFetch<{ isOnMirror: boolean } | ErrorResponse>(
      `${API}/mirror/${walletAddress}/has-posts`,
      {
        // 12 hour cache.
        next: { revalidate: 43200 },
      },
      {
        ignoreImpersonation: true,
        bypassCookies: true,
      }
    )

    if (isErrorResponse(response)) {
      return false
    }

    return response.isOnMirror
  } catch (error) {
    console.error("Error checking Mirror status:", error)
    return false
  }
}

export async function getMirrorPosts(
  walletAddress: string
): Promise<Array<ProcessedEntry> | null> {
  try {
    const response = await customFetch<
      { feed: Array<ProcessedEntry> } | ErrorResponse
    >(`${API}/mirror/${walletAddress}`)

    if (isErrorResponse(response)) {
      toast.error(response.msg)
      return null
    }

    return response.feed
  } catch (error) {
    console.error("Error getting Mirror posts:", error)
    return null
  }
}

// This function is not used anywhere else in the codebase and has been removed
// If you need to import notes, use the importNoteExport function in notes.ts instead

// Example of how to use the importNoteExport function:
// import { importNoteExport } from 'lib/api/notes'
// const response = await importNoteExport(note, { overwrite: true, storeOnArweave: true })
